import React from 'react';
import './File.css';
import { ReactSVG } from 'react-svg';
import i18n from '../../../i18n/i18n.js';

class File extends React.Component {

  parent = null;
  fileInputRef = React.createRef();
  textInputRef = React.createRef();
  
  constructor(props) {
    super(props);

    this.parent = typeof props.parent != 'undefined' ? props.parent : null;
    this.ws_data = typeof props.ws_data != 'undefined' ? props.ws_data : null;

    this.state = {};
  }

  handleBrowse = (e) => {
    e.preventDefault();
    this.fileInputRef.current.click();
  }

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
        this.textInputRef.current.value = file.name;

        if (this.parent && this.parent.state.nowUploaded && this.parent.state.nowUploaded[this.ws_data.fieldname]) {
          const nowUploaded = { ...this.parent.state.nowUploaded };
          delete nowUploaded[this.ws_data.fieldname];
          this.parent.setState({ nowUploaded });
        }

        this.parent.handle_change(e, this.ws_data.fieldname, { force_value: '' });
        this.parent.handle_change(e, this.ws_data.fieldname + '_file', { force_value: file });
        this.parent.handle_change(e, this.ws_data.fieldname + '_text', { force_value: file.name });
    }
  }

  handleUpload = (e) => {
    e.preventDefault();
    const { formData } = this.parent.state;
    formData['upload'] = this.ws_data.fieldname + '_file'; 
    this.parent.setState({ formData }, () => {
        this.parent.load_form_data(true);
    });
  }

  render() {
    const ws_data = this.ws_data;

    return (
      <div className="row">
        {ws_data.label ? <label htmlFor={`${ws_data.fieldname}_file`} className="form_label">{ws_data.label}{ws_data.required ? ' *' : ''}</label> : ''}
        {ws_data.explanation ? <div className="form_explanation" dangerouslySetInnerHTML={{__html: ws_data.explanation}}></div> : ''}
        <div className="form_panel_category_file_uploader">
          <input 
            type="text" 
            name={`${ws_data.fieldname}_text`} 
            id={`${ws_data.fieldname}_text`} 
            className="object_text_file init_onload_dragndrop" 
            readOnly={true} 
            placeholder={i18n.t('noFileSelected')}
            ref={this.textInputRef}
            defaultValue={
              (this.parent?.state?.nowUploaded && this.parent.state.nowUploaded[ws_data.fieldname])
              ? (Array.isArray(this.parent.state.nowUploaded[ws_data.fieldname]) ? this.parent.state.nowUploaded[ws_data.fieldname][0] : this.parent.state.nowUploaded[ws_data.fieldname]) 
              : (ws_data.default_filename || '')
            }
          />
          <input 
            type="file" 
            name={`${ws_data.fieldname}_file`} 
            id={`${ws_data.fieldname}_file`} 
            className="object_file"
            ref={this.fileInputRef}
            onChange={this.handleFileChange}
          />
          <button type="button" title={i18n.t('browse')} className="browse_button" onClick={this.handleBrowse}><ReactSVG src="/assets/images/browse.svg" /></button>
          <button type="button" title={i18n.t('upload')} className="upload_button" onClick={this.handleUpload}><ReactSVG src="/assets/images/upload.svg" /></button>
        </div>
        <div className="form_panel_category_file_viewer">
            {
              (this.parent?.state?.nowUploaded && this.parent.state.nowUploaded[ws_data.fieldname])
              ? <div>{i18n.t('successfulUpload')} {
                  Array.isArray(this.parent.state.nowUploaded[ws_data.fieldname]) 
                  ? this.parent.state.nowUploaded[ws_data.fieldname][0] 
                  : this.parent.state.nowUploaded[ws_data.fieldname]
                }</div>
              : (ws_data.file_viewer_content || i18n.t('noFileUploadedYet'))
            }
        </div>
        
        {this.parent.render_form_error(ws_data.fieldname)}
      </div>
    );
  }
};

export default File;
